import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store'

Vue.use(VueI18n)

const messages = {
  'fr': {
    nav: {
      home: 'Accueil',
      rooms: 'Chambres',
      discover: 'Découvrir',
      bookings: 'Réservations',
      contact: 'Contact & Accès',
      terms: 'Conditions générales',
      tourism: 'Tourisme',
      compostelle: 'Compostelle',
      guests_book: 'Livre d\'Or',
      reviews: 'Avis',
    },
    home: {
      part1: 'Sophie et Bertrand vous reçoivent à Cahors, dans leurs chambres d’hôtes de la Maison de la Marchande.<br>Construite en 1760, la maison est entourée d’un grand jardin dans lequel sont plantés des arbres centenaires.',
      part2: "La Maison de la Marchande vous accueille dans 4 chambres confortables et lumineuses, avec douche et WC privés. La maison a été entièrement rénovée en 2019. Les petits déjeuners sont servis dans la salle à manger familiale ou dehors si le temps le permet. Ainsi que les dîners proposés aux randonneurs.",
      part3: "La maison est située en bordure du Chemin de Saint Jacques de Compostelle (GR65), 4.5km avant le centre de Cahors. Ouverture de Mai à la Toussaint et sur demande le reste de l’année.",
      part4: "Pour vous relaxer, vous profitez d’un coin salon. Des jeux de société et des livres sont à votre disposition. Vous pouvez vous détendre dans le jardin, ping-pong, terrain de pétanque, Mölkky ou farniente sur une chaise longue.",
      gallery: "Voir la galerie",
      discover: "Découvrir la région",
      rooms: "Voir nos chambres",
      message: "La Maison de la Marchande vous souhaite une bonne année 2022!"
    },
    room:{
      see: 'Voir la chambre',
      description: "<p>La chambre comporte 2 lits de 90x200 et sa propre salle de douche et WC. Elle peut accueillir deux adultes. Le tarif est de :</p>\
      <p>\
        - 90 euros la nuit pour deux personnes. Nuit supplémentaire, réduction de 10 euros.<br>\
        - 65 euros la nuit pour une personne. Nuit supplémentaire, réduction de 5 euros.<br>\
        - La taxe de séjour à prévoir en plus de 0.98 euro par personne et par jour.<br>\
        - Le petit déjeuner est inclus dans le tarif de la chambre.<br>\
        - Le linge de lit et de toilette est fourni.<br>\
        - Un accès wifi est disponible gratuitement.<br>\
      </p>\
      <p>Pour les pèlerins du chemin de Saint Jacques de Compostelle, nous proposons un dîner au prix de 17 euros.</p>\
      <p>Les arrivées se font à partir de 16h et jusqu'à 19h. Les chambres doivent être libérées à 10h. Le petit-déjeuner est servi entre 7h15 et 9h15. La Maison de la Marchande est une chambre d'hôtes non-fumeurs. Nous regrettons de ne pouvoir accepter les animaux.</p>",
      others: 'Nos autres chambres',
      mentions: "<p>Nos conditions générales de vente :</p>\
        <p>\
          Nous demandons le versement de 30% d'arrhes à la réservation, calculées sur la durée de votre séjour (ce règlement se fait par chèque ou PayPal). Pour le règlement de votre séjour, nous acceptons chèque, espèces et PayPal. À ce jour, nous n'acceptons pas la carte bancaire. L’ensemble des prix est affiché TTC. Nous ne sommes pas assujettis à la TVA.\
        </p>\
        <p>Annulation de séjour: Jusqu’à 7 jours, restitution des arrhes. Moins de 7 jours, nous nous réservons la possibilité de vous demander le règlement complet de votre séjour.</p>\
        <p>Les arrivées se font à partir de 16h et jusqu'à 19h. Les chambres doivent être libérées à 10h. Le petit-déjeuner est servi entre 7h15 et 9h15. La Maison de la Marchande est une chambre d'hôtes non-fumeurs. Nous regrettons ne de pouvoir accepter les animaux.</p>"
    },
    discover: {
      title: 'Tourisme',
      subtitle: 'Pour tous les visiteurs, le Lot et Cahors regorgent de trésors à découvrir : le pont Valentré, la cathédrale Saint-Etienne, les jardins secrets,  et nombreux produits du terroir ...',
      tourism1: "Pour déguster de bons vins de Cahors, nous vous recommandons :<br>\
          À 800m de la maison,  <a target=\"_blank\" href=\"https://oulievindecahors.jimdofree.com/\">Les hauts de St Georges</a><br>\
          À Cieurac, à 4km de la maison <a target=\"_blank\" href=\"https://hauteserre.fr/fr/\">Le château de Haute Serre</a><br>\
          À Fages, <a href=\"http://www.lescroisille.com\" target=\"_blank\">Le château de Croisille</a><br>\
          À Labastide Marniac, <a href=\"https://www.domainedelagarde.com/\" target=\"_blank\">le domaine de la Garde</a>",
      tourism2: "Dans les environs : Saint-Cirq-Lapopie, Rocamadour, les grottes de Pech Merle, le gouffre de Padirac, les phosphatières du cloup d’Aural...(plus d’informations sur le site <a href=\"http://www.tourisme-cahors.fr/\" target=\"_blank\">l'office du tourisme de Cahors</a>)<br>\
        Et pour les marcheurs ou les cyclistes, <a href=\"https://www.tourisme-lot.com/balades-et-randonnees\" target=\"_blank\">une centaine de randonnées à proximité.</a>",
      tourism3: "Vous cherchez plutôt à loger dans un gîte , nous vous recommandons<br>\
          A Flaujac poujols, <a target=\"_blank\" href=\"http://annelaureperrone.com/clos-fonelle/?page=clos-fonelle\">le Clos de la fonelle</a><br>\
          A Lalbenque, <a target=\"_blank\" href=\"https://giteroujolis.wixsite.com/gite\">le gîte Rougolis</a>",
      compostelle: "Chemin de Compostelle",
      content: "La Maison de la Marchande se situe le long du GR65 à 4.5km du centre ville. Les pèlerins en chemin vers Saint Jacques de Compostelle qui empruntent la voie du Puy en Velay(<a href=\"https://www.chemins-compostelle.com/sites/all/modules/itineraire/carte.php?id=10\" target=\"_blank\">via Podiensis</a>) passent devant la maison.\
        Plus d'informations sur le site des <a href=\"https://www.chemins-compostelle.com/\" target=\"_blank\">chemins de compostelle</a>.</p>\
        <p>Les randonneurs utilisent parfois les services de« la malle postale» pour transporter leurs bagages. La Maison de la Marchande est <a href=\"https://www.lamallepostale.com/fr/\" target=\"_blank\">référencée</a> chez eux</p>\
        <p>Si votre pèlerinage démarre ou se termine à Cahors, nous pouvons venir vous chercher ou vous déposer à la gare. \
        En cas de besoin, nous pouvons faire une navette dans l’après-midi pour ceux qui sont à pied et souhaitent visiter Cahors. Nous proposons un dîner pour les pèlerins, au prix de 17 euros.</p>"
    },
    rates: {
      description: "<p>Chaque chambre peut accueillir deux adultes. Le tarif est de :</p>\
      <ul>\
        <li>90 euros une nuit pour deux personnes. Nuit supplémentaire, réduction de 10 euros.</li>\
        <li>65 euros une nuit pour une personne. Nuit supplémentaire, réduction de 5 euros.</li>\
        <li>Le petit déjeuner est inclus dans le tarif de la chambre.</li>\
        <li>Taxe de séjour à prévoir en plus  de 0,75 euro par personne et par jour.</li>\
      </ul>\
      <p>Pour les randonneurs du chemin de Saint Jacques de Compostelle, nous proposons un dîner au prix de 1 euros.<p>\
      <p>L’ensemble des prix est TTC. Nous ne sommes pas assujettis à la TVA.</p>\
      <p>Nous demandons le versement de 30% d'arrhes à la réservation, calculées sur la durée de votre séjour. Ce règlement se fait par chèque ou PayPal.<br>\
      Pour le règlement de votre séjour, nous acceptons chèque, espèces et PayPal. A ce jour, nous n'acceptons pas la carte bancaire.</p>\
      <p>Nos conditions générales de vente :</p>\
      <p>\
      - Les arrivées se font à partir de 16h et jusqu'à 19h.<br>\
      - Les chambres doivent être libérées à 10h.<br>\
      - Le petit-déjeuner, inclus dans le séjour, est servi entre 7h15 et 9h15.<br>\
      </p>\
      <p>La Maison de la Marchande est une chambre d'hôtes non-fumeurs. Nous regrettons ne de pouvoir accepter les animaux.</p>\
      <p>Annulation de séjour :</p>\
      <ul>\
        <li>Jusqu’à 7 jours, restitution des arrhes.</li>\
        <li>Moins de 7 jours, nous nous réservons la possibilité de vous demander le règlement complet de votre séjour.</li>\
      </ul>",
      data: "Le respect de vos données personnelles :",
      data_desc: "Afin de communiquer avec vous avant votre séjour et rester en contact ensuite, nous collectons certaines de vos données personnelles, notamment votre nom, adresse, email et numéro de téléphone. \
      Vos dates de séjour sont également enregistrées dans notre système de réservation.<br> Conformément à la législation sur la gestion des données personnelles, \
      nous sollicitons votre consentement pour collecter et enregistrer ces données, qui nous sont nécessaires pour bien vous accueillir. \
      Nous conservons ces données afin d'avoir la possibilité, le cas échéant, de vous tenir informés de l'actualité de la Maison de la Marchande."

    },
    conditions: {
      title: 'Tarif et conditions générales',
      part1: '<p>Chaque chambre comporte 2 lits de 90x200 et sa propre salle de douche et WC.<br>\
        Elle peut accueillir deux adultes. Le tarif est de :</p>\
        <ul>\
        <li>90 euros la nuit pour deux personnes. Nuit supplémentaire, réduction de \
        10 euros.</li>\
        <li>65 euros la nuit pour une personne. Nuit supplémentaire, réduction de 5 \
        euros.</li>\
          <li>La taxe de séjour à prévoir en plus de 0.98 euro par personne et par jour.</li>\
          <li>Le petit déjeuner est inclus dans le tarif de la chambre.</li>\
          <li>Le linge de lit et de toilette est fourni.</li>\
          <li>Un accès wifi est disponible gratuitement.</li>\
        </ul>',
      part2: '<p>Exclusivement pour les pèlerins du chemin de Saint Jacques de \
        Compostelle, qui arrivent à pied chez nous, nous proposons un dîner au \
        prix de 17 euros.</p>\
        <ul>\
          <li>Les arrivées se font à partir de 16h et jusqu\'à 19h.</li>\
          <li>Les chambres doivent être libérées à 10h.</li>\
          <li>Le petit-déjeuner est servi entre 7h15 et 9h15.</li>\
          <li>La Maison de la Marchande est une chambre d\'hôtes non-fumeurs.</li>\
          <li>Nous regrettons de ne pouvoir accepter les animaux.</li>\
        </ul>',
      terms: "<p>Nos conditions générales de vente :</p>\
        <p>\
          Nous demandons le versement de 30% d'arrhes à la réservation, calculées sur la durée de votre séjour (ce règlement se fait par chèque). Pour le règlement de votre séjour, nous acceptons chèque, espèces et CB. L’ensemble des prix est affiché TTC. Nous ne sommes pas assujettis à la TVA.\
        </p>\
        <p>Annulation de séjour: Jusqu’à 7 jours, restitution des arrhes. Moins de 7 jours, nous nous réservons la possibilité de vous demander le règlement complet de votre séjour.</p>",
    },
    contact: {
      left1: "<b> Contact: </b><br>Par téléphone au + 33 6 62 25 70 51.<br>Par email : <a href=\"mailto:contact@maisondelamarchande.fr\" target=\"_blank\">contact@maisondelamarchande.fr</a>",
      left2: "<b>Accès : </b><br>\
          Adresse : 31 chemin de la Marchande, 46000 Cahors <br>\
          Coordonnées GPS : <a  href=\"https://www.google.com/search?q=44.412210,+1.468758&oq=44.412210\" target=\"_blank\">44.412210, 1.468758</a><br>\
          En voiture: par l’autoroute A20, à 12 minutes de la sortie 58 - Cahors Sud<br>\
          À pied : le GR65 emprunte Le chemin de la marchande <br>"
   },
   reviews: {
    info: 'Les avis présentés ici proviennent d\'avis spontanés, soit de <a href="https://www.google.com/travel/hotels/maison%20de%20la%20marchande/entity/CgoI3O3m1fa5399REAE/reviews" target="_blank">Google</a>, soit de <a href="https://www.cahorsvalleedulot.com/hebergements/maison-de-la-marchande/" target="_blank">l\'office du tourisme de Cahors</a>.'
   }
  },
  'en': {
    nav: {
      home: 'Home',
      rooms: 'Rooms',
      discover: 'Discover',
      bookings: 'Bookings',
      contact: 'Contact & Access',
      tourism: 'Tourism',
      terms: 'Terms & Conditions',
      compostelle: 'St. James',
      guests_book: 'Guest book',
      reviews: 'Reviews',
    },
    home: {
      part1: 'Sophie and Bertrand welcome you to Cahors, in their guest house called Maison de la Marchande.<br>Built in 1760, the house is surrounded by a big garden where you\'ll find centennial trees ',
      part2: "Maison de la Marchande offers 4 luminous and comfortable rooms, all equipped with private shower and toilet. The house was entirely renovated in 2019. Breakfast is served in the family dining room, or outside when weather permits it. As well as the dinner for our pilgrim guests.",
      part3: "The house is located at the border of the Way of St. James of Compostela (GR65), 4.5km before Cahors city centre. We are open from May till end of October, and on demand for the rest of the year.",
      part4: "During your stay, you can enjoy our relaxing living room, board games and books are at your disposal. You can also take advantage of the garden: table tennis, pétanque, Mölkky or just lie down on a long chair.",
      gallery: "See the gallery",
      discover: "Discover the region",
      rooms: "See our rooms",
      message: "Maison de la Marchande wishes you a happy new year 2022!"
    },
    room:{
      see: 'See the room',
      description: "<p>The room includes 2 90x200 beds and its own bathroom. Maximum of 2 adults per room. The rates are:</p>\
      <p>\
        - 90 euros for 2 person for 1 night. Every additional night comes with a 10 euros discount.<br>\
        - 65 euros for 1 person for 1 night. Every additional night comes with a 5 euros discount.<br>\
        - The tourist tax amounts to 0.98 euro per person and per day.<br>\
        - Breakfast is included.<br>\
        - Clean sheets and towels included.<br>\
        - Free wifi is available.<br>\
      </p>\
      <p>For the Camino de Santiago pilgrims, we offer dinner priced at 17 euros.</p>\
      <p>Check in is between 4PM and 7PM. Check out must be done by 10AM or earlier. Breakfast is served between 7:15AM and 9:15AM. Maison de la Marchande is a smoke free guest house. We regret to inform you we cannot accept pets.</p>",
      others: 'Our other rooms',
    },
    rates: {
      description: "<p>Each room can host up to 2 adults. 2024 rates are :</p>\
      <ul>\
        <li>90 euros for 2 person for 1 night. Every additional night comes with a 10 euros discount.</li>\
        <li>65 euros for 1 person for 1 night. Every additional night comes with a 5 euros discount.</li>\
        <li>Breakfast is included.</li>\
        <li>The tourist tax amounts to 0.98 euro per person and per day.</li>\
      </ul>\
      <p>For the Camino de Santiago pilgrims, we offer dinner priced at 17 euros.<p>\
      <p> All of the prices displayed include tax.</p>\
      <p> We ask for a 30% deposit at booking, based on the duration of your stay (this deposit can be done via check or Paypal).<br>\
      For the rest of the payment, we accept checks, cash and Paypal. Unfortunately we do not accept credit card.</p>\
      <p>Our terms of sales :</p>\
      <p>\
      - Check in is between 4PM and 7PM.<br>\
      - Check out must be done at 10AM or earlier.<br>\
      - Breakfast is served between 7:15AM and 9:15AM.<br>\
      </p>\
      <p>Maison de la Marchande is a smoke free guest house. We regret to inform you we cannot accept pets.</p>\
      <p>Cancellation of your stay :</p>\
      <ul>\
        <li>More than 7 days, deposit is reimbursed.</li>\
        <li>Less than 7 days, we reserve the right to ask you for the full payment of your stay.</li>\
      </ul>",
      data: "Your personal data :",
      data_desc: "In order to communicate with your before your stay and keep in touch after, we collect some of your personal data, including your name, address, email and phone number.\
      Your check in and check out dates are also saved in our booking system.<br> In accordance with the law regarding personal data, \
      we ask your consent to collect and save this data, which is necessary to give you a proper welcome and stay. \
      We save this data to be able to, if that's the case, send you news about Maison de la Marchande."
    }
    ,
    discover: {
      title: 'Tourism',
      subtitle: 'For all the visitors, the Lot and Cahors are full of treasures to discover : the Vallentré bridge, the Saint-Etienne cathedral, the secret gardens, and many local products ...',
      tourism1: "Many wines are produced around Cahors, we recommend :<br>\
          800m from the house,  <a target=\"_blank\" href=\"https://oulievindecahors.jimdofree.com/\">Les hauts de St Georges</a><br>\
          At Cieurac, 4km from the house <a target=\"_blank\" href=\"https://hauteserre.fr/fr/\">Haute Serre castle</a><br>\
          At Fages, <a href=\"http://www.lescroisille.com\" target=\"_blank\">Croisille castle</a><br>\
          At Labastide Marniac, <a href=\"https://www.domainedelagarde.com/\" target=\"_blank\">la Garde's domain</a>",
      tourism2: "A bit further : Saint-Cirq-Lapopie, Rocamadour, Pech Merle's cave, Padirac Pit, the mines of cloup d'Aural......(more informations on <a href=\"http://www.tourisme-cahors.fr/\" target=\"_blank\">Cahors' tourism office</a> website)<br>\
        And for the pilgrims and cyclists, <a href=\"https://www.tourisme-lot.com/balades-et-randonnees\" target=\"_blank\">more than a hundred hiking paths.</a>",
      tourism3: "If you're looking for lodging, we recommend : <br>\
          At Flaujac poujols, <a target=\"_blank\" href=\"http://annelaureperrone.com/clos-fonelle/?page=clos-fonelle\">le Clos de la fonelle</a><br>\
          At Lalbenque, <a target=\"_blank\" href=\"https://giteroujolis.wixsite.com/gite\">Rougolis' lodging</a>",
      compostelle: "Camino de Santiago",
      content: "<p>Maison de la Marchande is located along the GR65, 4.5km from the city centre. Pilgrims on their route to Santiago who come from Le Puy en Velay(<a href=\"https://www.chemins-compostelle.com/sites/all/modules/itineraire/carte.php?id=10\" target=\"_blank\">through Podiensis</a>) walk by the house.\
        More informations on the website <a href=\"https://www.chemins-compostelle.com/\" target=\"_blank\">chemins-compostelle.com</a>.</p>\
        <p>The pilgrims sometimes use a service called « la malle postale» to transit their luggages. Maison de la Marchande is <a href=\"https://www.lamallepostale.com/fr/\" target=\"_blank\">referenced</a> on their website</p>\
        <p>If your pilgrimage begins or ends in Cahors, we can pick you up or drop you off at the train station. \
        In case it's needed, we can transport you if you are on foot and want to spend the afternoon to visit Cahors. We offer dinner for the pilgrims, at the rate of 17 euros.</p>"
    },
    conditions: {
      title: 'Terms & conditions',
      part1: '<p>Each room includes 2 90x200 beds and its own bathroom.<br>\
        Maximum of 2 adults per room. The rates are:</p>\
        <ul>\
          <li>90 euros for 2 person for 1 night. Every additional night comes with a 10 euros discount.</li>\
          <li>The tourist tax amounts to 0.98 euro per person and per day.</li>\
          <li>65 euros for 1 person for 1 night. Every additional night comes with a 5 euros discount.</li>\
          <li>Breakfast is included.</li>\
          <li>Clean sheets and towels included.</li>\
          <li>Free wifi is available.</li>\
        </ul>',
      part2: '<p>Exclusively for the Camino de Santiagoo pilgrims, who arrive by foot, we offer dinner priced at 17 euros.</p>\
        <ul>\
          <li>Check in is between 4PM and 7PM.</li>\
          <li>Check out must be done at 10AM or earlier.</li>\
          <li>Breakfast is served between 7:15AM and 9:15AM.</li>\
          <li>Maison de la Marchande is a smoke free guest house.</li>\
          <li>We regret to inform you we cannot accept pets.</li>\
        </ul>',
      terms: '<p>Our terms of sale are :</p>\
        <p>\
          We ask for a 30% deposit at booking, based on the duration of your stay (this deposit can be done via check). For the rest of the payment, we accept checks, cash and credit card.<br>All our prices include tax.\
        </p>\
        <p>Cancellation: More than 7 days, deposit is reimbursed. Less than 7 days, we reserve the right to ask you for the full payment of your stay.</p>',
    },
    contact: {
      left1: "<b> Contact: </b><br>By phone + 33 6 62 25 70 51.<br>By email : <a href=\"mailto:contact@maisondelamarchande.fr\" target=\"_blank\">contact@maisondelamarchande.fr</a>",
      left2: "<b>Access : </b><br>\
          Address : 31 chemin de la Marchande, 46000 Cahors <br>\
          GPS Coordinates : <a  href=\"https://www.google.com/search?q=44.412210,+1.468758&oq=44.412210\" target=\"_blank\">44.412210, 1.468758</a><br>\
          By Car: take highway A20, 12 minutes from exit 58 - south of Cahors<br>\
          By foot : Le chemin de la marchande is part of the GR65<br>"
    },
    reviews: {
      info: 'The reviews displayed here come from spontaneous reviews posted on either <a href="https://www.google.com/travel/hotels/maison%20de%20la%20marchande/entity/CgoI3O3m1fa5399REAE/reviews" target="_blank">Google</a>, or <a href="https://www.cahorsvalleedulot.com/hebergements/maison-de-la-marchande/" target="_blank">the Cahors tourism office</a>.'
    }

  }
}

export default new VueI18n({
  locale: store.state.app.locale, // set locale
  messages, // set locale messages
})
